import React from "react";
import { Link } from "react-router-dom";
import FAQsAccordion from "./FAQsAccordion";
import ContactForm from "../../Contact/Cantact-page/ContactForm";
import HelpGettingStarted from "./HelpGettingStarted";
import HelpHeader from "./HelpHeader";
import ComparisonCard from "./ComparisonCard";

const Help = () => {
  return (
    <>
    <div className="hidden lg:block help">
        <div className="w-[15.5] flex flex-col pt-[20vh]">
          <div className="text-[2.6vw] font-semibold text-white">Help</div>
          <div className="text-white flex gap-3 justify-center text-[1vw] font-urbanist">
            <Link to="/">
              <button className="hover:text-white hover:scale-110 duration-150">
                Home
              </button>
            </Link>
            /
            <button className="hover:text-white hover:scale-110 duration-150">
              Help
            </button>
          </div>
        </div>
      </div>
      <div className=" w-[342px] md:w-[74vw] mx-auto sm:py-[2vw] py-[40px]">
        <HelpHeader/>

      <ComparisonCard />

        <div className="text-[18px] md:text-20 text-lux-black font-urbanist text-center px-6 my-10">
          BidCaribeean, a Lux First Choice Car Division, is a leading online auction platform providing trustworthy services, reliable support, and an uncomplicated buying experience, making us the first choice for the Caribbean.
          </div>

        <HelpGettingStarted/>
        <FAQsAccordion />
        <ContactForm />
      </div>
    </>
  );
};

export default Help;
